var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.releaseDate
    ? _c("span", [
        _vm._v(" · "),
        _c("span", [
          _vm._v(
            "Deployed: " +
              _vm._s(_vm.releaseDate) +
              " (" +
              _vm._s(_vm.releaseHash) +
              ")"
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }